
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';
import { Organization } from '@/types/organizationTypes';

export interface AccountStatus {
  isFullyOnboarded: boolean;
  requiresAction: boolean;
  actionNeeded?: string;
  charges_enabled?: boolean;
  payouts_enabled?: boolean;
  details_submitted?: boolean;
}

export const useStripeAccountStatus = (organization: Organization | null) => {
  const [loading, setLoading] = useState(false);
  const [accountStatus, setAccountStatus] = useState<'none' | 'connected' | 'pending' | 'error'>('none');
  const [detailedStatus, setDetailedStatus] = useState<AccountStatus | null>(null);
  const stripeAccountId = organization?.billing_settings?.stripe_account_id || null;

  const fetchAccountStatus = async () => {
    if (!stripeAccountId) return;

    try {
      const { data, error } = await supabase.functions.invoke('check-connect-account-status', {
        body: { accountId: stripeAccountId }
      });

      if (error) throw error;

      setDetailedStatus(data);
      
      if (data.isFullyOnboarded) {
        setAccountStatus('connected');
      } else if (data.requiresAction) {
        setAccountStatus('pending');
      }
    } catch (error) {
      console.error('Error fetching account status:', error);
      toast.error('Failed to fetch account status');
    }
  };

  useEffect(() => {
    if (stripeAccountId) {
      setAccountStatus('connected');
      fetchAccountStatus();
    } else {
      setAccountStatus('none');
    }
  }, [stripeAccountId]);

  return {
    loading,
    accountStatus,
    detailedStatus,
    fetchAccountStatus
  };
};
